import { useEffect } from 'react';
import { connectCartaConfigSync } from '../config/WebsocketService';
import { queryClient, queryKeys } from '../config/queryClient';

/**
 * Mantiene la carta sincronizada con cambios de configuración en tiempo real.
 * Escucha el topic público de configuración y refetch de React Query al recibir
 * un cambio de la sucursal activa.
 */
export const useCartaConfigSync = (shopBranchId) => {
  useEffect(() => {
    if (!shopBranchId) {
      return undefined;
    }

    return connectCartaConfigSync(shopBranchId, () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.branchConfig(shopBranchId),
      });
    });
  }, [shopBranchId]);
};
